"use strict";
import "../../../public/javascripts/campaigns/sms_length_preview.js";
export const SmsLengthPreview = window.SmsLengthPreview;
